import uniqueId from 'lodash/uniqueId';
import actionFactory from '../props/action';
import paddingModifier from '../props/padding-modifier';
import size, { SIZE } from '../props/size';
import numberHelper from '../props/number-helper';
import { DEFAULT_DELIMITER_COLOR } from '../const';

/**
 * Парсер блока div-separator-block
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-separator-block.json
 * @param  {Object} block
 * @return {Object}
 */
export default (function (block) {
    var _block$delimiter_colo = block.delimiter_color,
        color = _block$delimiter_colo === undefined ? DEFAULT_DELIMITER_COLOR : _block$delimiter_colo;


    return {
        color: color,
        hasDelimiter: Boolean(block.has_delimiter),
        action: actionFactory(block),
        size: size(block.size, SIZE.xs),
        paddingModifier: paddingModifier(block),
        type: block.type,
        id: uniqueId('block_'),
        separatorWeight: numberHelper(block.weight, 1),
        weight: 0
    };
});